import * as React from 'react';
import { Switch, UIHeading4 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as styles from './RecommendationsToggle.css';
export var RecommendationsToggle = function RecommendationsToggle(_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled,
      mobile = _ref.mobile,
      onChange = _ref.onChange;
  var handleChange = React.useCallback(function (event, value) {
    onChange(value);
  }, [onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['toggle-container'], mobile && styles['mobile'])
  }, /*#__PURE__*/React.createElement(Switch, {
    onChange: handleChange,
    checked: checked,
    disabled: disabled
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['label']
  }, /*#__PURE__*/React.createElement(UIHeading4, {
    as: "h4"
  }, "\u0417\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0437\u0432\u043E\u043D\u043E\u043A \u0443\xA0\u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u043E\u0432 \u0441\xA0\u043F\u043E\u0445\u043E\u0436\u0438\u043C \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043C")));
};